var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningCircleSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.001 2.3c5.357 0 9.7 4.343 9.7 9.7s-4.343 9.7-9.7 9.7-9.7-4.343-9.7-9.7S6.644 2.3 12 2.3m.007 13.134a.9.9 0 0 0-.9.899v.008a.9.9 0 0 0 1.8 0v-.008a.9.9 0 0 0-.9-.9M12 6.3a.7.7 0 0 0-.7.7v6a.7.7 0 0 0 1.4 0V7a.7.7 0 0 0-.7-.7",
  clipRule: "evenodd"
})));
export default SvgWarningCircleSolid;